import { render, staticRenderFns } from "./OrderRejectNotice.vue?vue&type=template&id=ecb2cb74&scoped=true"
import script from "./OrderRejectNotice.vue?vue&type=script&lang=js"
export * from "./OrderRejectNotice.vue?vue&type=script&lang=js"
import style0 from "./OrderRejectNotice.vue?vue&type=style&index=0&id=ecb2cb74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb2cb74",
  null
  
)

export default component.exports